<div class="review-page">
  <div class="container">
    <a
      (click)="downloadPdf()"
      id="download-pdf-link"
    ><i class="sch-download"></i>PDF</a>
    <div
      class="print-content"
      id="print-review-page"
    >
      <img
        alt="Charles Schwab"
        id="print-logo"
        src="./static/assets/images/cs_logo-04.png"
        width="100"
        height="100"
      >
      <span
        id="review-page-header"
        class="section-title"
      >Review</span>
      <mm-spinner
        [loading]="reviewPageComponentState$"
        [makeInert]="false"
      ></mm-spinner>
      <!--Display Initiate and release non iso error when non iso txn is released during iso ea/ga-->
      <!--All other error/warning banners can be skipped since the txn is invalid and will require deletion-->
      <ng-container *ngIf="isNonIsoCompliantTransactionReleasorFlow; else regularErrorBanner">
        <mm-banners
          id="invalid-non-iso-inr-error"
          data-testid="invalid-non-iso-inr-error"
          [bannerText]="[nonIsoCompliantTxnInRError]"
          [type]="'error'"
        ></mm-banners>
      </ng-container>
      <ng-template #regularErrorBanner>
        <ng-container
          *ngIf="(hasBadRequestServiceError || hasAtpTimeoutError)"
          class="no-print"
        >
          <div *ngIf="!isErrorFromOneTimeCreateSloaToggleOn || !isErrorSubmit">
            <mm-banners
              *ngFor="let error of serviceErrorList"
              [bannerText]="[error]"
              [type]="'error'"
              id="reviewPage_badRequestServiceError"
              data-testid="reviewPage_badRequestServiceError"
            ></mm-banners>
          </div>
          <div *ngIf="isErrorFromOneTimeCreateSloaToggleOn || isErrorSubmit">
            <mm-banners
              [bannerText]="[atpErrorOnSubmitToggleOnBannerMessage]"
              [titleText]="atpErrorOnSubmitToggleOnBannerTitleText"
              [shouldBoldTitleText]="true"
              [routeRedirect]="errorLink"
              [type]="'warning'"
              id="reviewPage_badRequestServiceError"
              data-testid="reviewPage_badRequestServiceError"
            ></mm-banners>
          </div>
        </ng-container>
        <mm-banners
          *ngIf="hasServiceError"
          class="no-print"
          [serviceError]="(transactionFormServiceError$ | async)!"
          [isInRFromTableDuplicateDraftsEnabled]="isInitiateAndReleaseFlowFromTable"
          [type]="'error'"
          id="reviewPage_serviceError"
          data-testid="reviewPage_serviceError"
        ></mm-banners>
        <mm-banners
          *ngIf="displayWarning"
          class="no-print"
          [bannerText]="[warningText]"
          [type]="'warning'"
        ></mm-banners>
        <mm-banners
          id="multiple-validation-errors"
          *ngIf="multipleVerifyErrors.length > 0"
          [useBulletedListDisplay]="true"
          [titleText]="multipleVerifyErrorsTitleText"
          [bannerText]="multipleVerifyErrors"
          [type]="'error'"
        ></mm-banners>
        <mm-banners
          id="single-revalidation-error"
          class="revalidation_error_warning"
          *ngIf="displayRevalidationError && multipleRevalidationError.length == 0"
          [bannerText]="[singleRevalidationError]"
          [type]="'error'"
        ></mm-banners>
        <mm-banners
          id="multiple-revalidation-error"
          class="revalidation_error_warning"
          *ngIf="displayRevalidationError && multipleRevalidationError.length > 1"
          [useBulletedListDisplay]="true"
          [bannerText]="multipleRevalidationError"
          [type]="'error'"
        ></mm-banners>
        <mm-banners
          id="single-revalidation-warning"
          class="revalidation_error_warning"
          *ngIf="displayRevalidationWarning && multipleRevalidationWarning.length == 0"
          [bannerText]="[singleRevalidationWarning]"
          [type]="'warning'"
        ></mm-banners>
        <mm-banners
          id="multiple-revalidation-warning"
          class="revalidation_error_warning"
          *ngIf="displayRevalidationWarning && multipleRevalidationWarning.length > 1"
          [useBulletedListDisplay]="true"
          [bannerText]="multipleRevalidationWarning"
          [type]="'warning'"
        ></mm-banners>
        <mm-banners
          *ngIf="transactionType === 'ach' && whichAchInfoUpdated().length > 0"
          [type]="'information'"
          [useBulletedListDisplay]="true"
          [bannerText]="whichAchInfoUpdated()"
          [titleText]="achUpdatedInformationBannerTitle"
          [showCloseIcon]="false"
        ></mm-banners>

        <mm-error-summary
          *ngIf="(submitClicked$ | async) && (hasError$ | async)"
          class="no-print"
          [errors]="errors"
          [summaryText]="errorSummaryText"
        ></mm-error-summary>
        <mm-banners
          *ngIf="attentionMessageRequired || showCharitableContributionBannerForReleaseFlow"
          [verifyAttentionMessage]="true"
          [stateTaxAttentionRequiredMI]="isStateTaxAttentionRequiredMI()"
          [stateTaxAttentionRequiredCT]="isStateTaxAttentionRequiredCT()"
          [stateTaxAttentionRequiredMN]="isStateTaxAttentionRequiredMN()"
          [RothSimpleTaxAttentionRequired]="isRothSimpleAgeIntoQualifiedDistributionCode"
          [charitableMessage]="isCharitableContribution()"
          [warningMessages]="warningMessages"
          [type]="'information'"
          id="reviewPage_attentionmessage"
        ></mm-banners>
      </ng-template>
      <div
        id="reviewPage_copy"
        class="review-page-copy"
      >
        <span>{{reviewPageCopy}}</span>
      </div>
      <mm-transaction-review-check
        *ngIf="isCheckTransaction" [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable"
        id="transaction-review-page"
        data-testid="transaction-review-check-component"
      ></mm-transaction-review-check>
      <mm-transaction-review-ach
        *ngIf="isAchTransaction"
        id="transaction-review-page"
        data-testid="transaction-review-ach-component"
      ></mm-transaction-review-ach>
      <mm-transaction-review-it
        *ngIf="isItTransaction && !useOriginalLayout"
        id="transaction-review-page"
        data-testid="transaction-review-it-component"
      ></mm-transaction-review-it>
      <mm-transaction-review-wire
        *ngIf="isWireTransaction() && !useOriginalLayout"
        id="transaction-review-page"
        data-testid="transaction-review-wire-component"
      ></mm-transaction-review-wire>
      <mm-transaction-review
        *ngIf="useOriginalLayout"
        id="transaction-review-page"
        [hasWireServiceError]="hasWireVerifyError"
        data-testid="transaction-review-component"
      ></mm-transaction-review>
      <div class="review-trust-comments-banner">
        <mm-banners
          *ngIf="displayTrustCommentWarning"
          class="sdps-messaging--warning"
          [bannerText]="[trustCommentWarningBannerText]"
          [type]="'warning'"
        ></mm-banners>
        <mm-transmission-notes 
            *ngIf="isWireTransaction() && !useOriginalLayout && !!transmissionNotes" 
            [transmissionNotes]="transmissionNotes" 
            [transmissionNotesLabel]="transmissionNotesLabel" 
            data-testid="transmission-notes">
        </mm-transmission-notes>
      </div>
      <sdps-divider
        id="bottom-divider"
        variation="secondary"
      ></sdps-divider>
      <div
        class="no-print"
        *ngIf="isPositionsTransaction(transferType)"
      >
        <!--Phase 2 Positions Table-->
        <mm-positions-table-multiple-review
          [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable"
        ></mm-positions-table-multiple-review>
        <br>
        <sdps-divider variation="secondary"></sdps-divider>
        <br>
      </div>
      <mm-client-authorization
        *ngIf="showAuthorizationDetails"
        [eAuthRestricted]="eAuthRestricted"
        [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable"
        [eAuthIneligible]="eAuthIneligible"
      >
      </mm-client-authorization>
    </div>
    <mm-options
      *ngIf="showOptions"
      class="no-print"
      [isClientAuthShown]="showClientAuthorization"
    ></mm-options>
    <mm-money-movement-acknowledgement-section *ngIf="showAcknowledgementSection"></mm-money-movement-acknowledgement-section>
    <button
      *ngIf="isEditEnabled"
      id="reviewPage_editButton"
      type="button"
      (click)="onEditClicked()"
      class="sdps-button sdps-button--small sdps-button--secondary no-print"
      [disabled]="shouldButtonsBeDisabled"
    >Edit</button>
    <button
      *ngIf="isBackButtonEnabled"
      id="reviewPage_editButton"
      type="button"
      (click)="onBackButtonClicked()"
      class="sdps-button sdps-button--small sdps-button--secondary no-print"
    >Back</button>
    <button
      *ngIf="!hasServiceErrorFORINRTable"
      id="reviewPage_cancelButton"
      type="button"
      (click)="onCancelClicked()"
      data-testid="reviewPage_cancelButton"
      class="sdps-button sdps-button--small sdps-button--secondary no-print"
      [disabled]="shouldButtonsBeDisabled"
    >Cancel</button>
    <button
      *ngIf="showSubmitButton"
      id="reviewPage_submitButton"
      data-testid="reviewPage_submitButton"
      type="button"
      [disabled]="shouldButtonsBeDisabled"
      (click)="onSubmit()"
      class="sdps-button sdps-button--primary sdps-button--small no-print"
    >{{submitButtonVerbiage}}</button>
    <button
      *ngIf="showCreatePDFButton"
      id="reviewPage_pdfSubmitButton"
      type="button"
      (click)="onSubmitAndCreatePDF()"
      class="sdps-button sdps-button--primary sdps-button--small no-print"
    >Create PDF</button>
    <mm-delete-initiated-draft-modal
      [showModal$]="deleteDraftClicked$.asObservable()"
      [currentDraft]="currentDraftInContext$.asObservable() | async"
      [isFromReviewPage]="true"
    ></mm-delete-initiated-draft-modal>
  </div>
</div>
